import * as React from "react";

export const VivazIcon = (props: any) => (
  <svg
    width={24}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.988 5.997 5.991 0 0 5.997l11.988 11.994 5.997-5.997 5.997-5.997H11.988Z"
      fill="#32C8C8"
    />
    <path
      d="M11.988 5.997 17.985 0l5.997 5.997H11.988Zm5.997 5.997-5.997-5.997-5.997 5.997h11.994Z"
      fill="#960064"
    />
  </svg>
);
